var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "lite_popup lite_preview"
    },
    [
      _c("div", { staticClass: "lite_popup_box" }, [
        _c("div", { staticClass: "lite_popup_title" }, [
          _c("span", [
            _vm._v(
              "Preview (" +
                _vm._s(_vm.currentIndex + 1) +
                "/" +
                _vm._s(_vm.files.length) +
                ") "
            ),
            _c("span", { staticStyle: { "margin-left": "20px" } }, [
              _vm._v(_vm._s(_vm.cur.name))
            ])
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: { click: _vm.close }
          })
        ]),
        _vm._v(" "),
        _vm.show
          ? _c("div", { staticClass: "lite_popup_content" }, [
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.fullscreenLoading,
                    expression: "fullscreenLoading"
                  }
                ],
                staticClass: "lite-preview-loading"
              }),
              _vm._v(" "),
              _vm.isImage && _vm.sizeOKForImage
                ? _c("img", {
                    staticClass: "preview_img",
                    attrs: { src: _vm.previewUrl }
                  })
                : _vm.isAudio
                ? _c("audio", {
                    staticClass: "preview_audio",
                    attrs: { src: _vm.previewUrl, controls: "" }
                  })
                : _vm.isVideo
                ? _c("video", {
                    staticClass: "preview_video",
                    attrs: { src: _vm.previewUrl, controls: "" }
                  })
                : _vm.isEml && _vm.sizeOKForEml
                ? _c("div", { staticClass: "preview_eml" }, [
                    _c("div", { staticClass: "preview_eml_header" }, [
                      _vm.eml.subject
                        ? _c("div", { staticClass: "preview_eml_subject" }, [
                            _vm._v(_vm._s(_vm.eml.subject))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.eml.from
                        ? _c("div", { staticClass: "preview_eml_meta" }, [
                            _c("span", [_vm._v("From:")]),
                            _vm._v(_vm._s(_vm.eml.from))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.eml.to
                        ? _c("div", { staticClass: "preview_eml_meta" }, [
                            _c("span", [_vm._v("To:")]),
                            _vm._v(_vm._s(_vm.eml.to))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.eml.cc
                        ? _c("div", { staticClass: "preview_eml_meta" }, [
                            _c("span", [_vm._v("Cc:")]),
                            _vm._v(_vm._s(_vm.eml.cc))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.eml.date
                        ? _c("div", { staticClass: "preview_eml_meta" }, [
                            _c("span", [_vm._v("Date:")]),
                            _vm._v(_vm._s(_vm.eml.date))
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("iframe", {
                      staticClass: "preview_eml_body",
                      attrs: { sandbox: "", srcdoc: _vm.eml.bodyHtml }
                    }),
                    _vm._v(" "),
                    _vm.eml.attachments.length
                      ? _c(
                          "div",
                          { staticClass: "preview_eml_attachments" },
                          [
                            _c(
                              "div",
                              { staticClass: "preview_eml_attachments_title" },
                              [
                                _vm._v(
                                  "Attachments (" +
                                    _vm._s(_vm.eml.attachments.length) +
                                    ")"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.eml.attachments, function(
                              attachment,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "preview_eml_attachment"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "preview_eml_attachment_name"
                                    },
                                    [_vm._v(_vm._s(attachment.name))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "preview_eml_attachment_meta"
                                    },
                                    [
                                      _vm._v(_vm._s(attachment.type)),
                                      attachment.size
                                        ? _c("span", [
                                            _vm._v(
                                              " - " +
                                                _vm._s(
                                                  _vm.formatBytes(
                                                    attachment.size
                                                  )
                                                )
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e()
                  ])
                : _vm.isText && _vm.sizeOKForText
                ? _c("pre", { staticClass: "preview_text" }, [
                    _vm._v(_vm._s(_vm.textContent))
                  ])
                : _c("div", { staticClass: "preview_info" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../assets/images/workspace/un_preview.png"),
                        draggable: "false"
                      }
                    }),
                    _vm._v(" "),
                    _vm.cur.dir
                      ? _c("div", [_c("b", [_vm._v(_vm._s(_vm.cur.name))])])
                      : _c("div", [
                          _vm._v(_vm._s(_vm.cur.name)),
                          _vm.cur.size
                            ? _c("span", [
                                _vm._v(
                                  " - " + _vm._s(_vm.formatBytes(_vm.cur.size))
                                )
                              ])
                            : _vm._e()
                        ]),
                    _vm._v(" "),
                    _c("div", [_vm._v(_vm._s(_vm.formatDate(_vm.cur.time)))]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(_vm._s(_vm.$t("language.preview.fileNotReview")))
                    ])
                  ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "lite_popup_footer" }, [
          _c(
            "button",
            {
              attrs: { disabled: _vm.currentIndex == 0 },
              on: {
                click: function($event) {
                  return _vm.prev()
                }
              }
            },
            [_vm._v("Prev")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: { disabled: _vm.currentIndex + 1 == _vm.files.length },
              on: {
                click: function($event) {
                  return _vm.next()
                }
              }
            },
            [_vm._v("Next")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53c40601", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53c40601","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_preview.vue
// module id = null
// module chunks = 